export const EMAIL_REGEX = /^[A-Z0-9.!#$%&'+\/=?^_`{|}~-]+@[A-Z0-9-]+(?:\.[A-Z0-9-]+){1,}$/i
